const initInputs = (root = document) => {
  if (!root) return;
  const rootEl = typeof root === 'string' ? document.querySelector(root) : root;
  if (!rootEl) return;

  rootEl.querySelectorAll('.form-element--icon').forEach((iconInput) => {
    const icon = iconInput.querySelector('.icon');
    const input = iconInput.querySelector('input');
    if (!icon || !input) return;

    if (input.type == 'password')
      icon.addEventListener('click', () => {
        iconInput.classList.toggle('active');
        input.type = input.type == 'password' ? 'text' : 'password';
      });
  });

  rootEl.querySelectorAll('.form-element--range').forEach((rangeWrapper) => {
    const rangeMin = rangeWrapper.querySelector('input[range-min]');
    const rangeMax = rangeWrapper.querySelector('input[range-max]');
    const rangeIndicator = rangeWrapper.querySelector('.range-indicator');

    if (!rangeIndicator) {
      console.error('Cannot initialize range input. Range indicator not found');
      return;
    }

    if (!rangeMin?.min || rangeMin?.min != rangeMax?.min) {
      console.error(
        'Cannot initialize range input. Range inputs have different min values',
      );
      return;
    }
    if (!rangeMin?.max || rangeMin?.max != rangeMax?.max) {
      console.error(
        'Cannot initialize range input. Range inputs have different max values',
      );
      return;
    }

    const range = parseInt(rangeMin.max) - parseInt(rangeMin.min);
    var minValue = parseInt(rangeMin.value);
    var maxValue = parseInt(rangeMax.value);
    const gap = parseInt(rangeMin?.dataset?.gap ?? rangeMax?.dataset?.gap) ?? 1;

    const updateIndicator = () => {
      const left = (minValue * 100) / range;
      const buffer = (maxValue * 100) / range;
      const right = 100 - buffer;
      rangeIndicator.style.left = `${left}%`;
      rangeIndicator.style.right = `${right}%`;
    };
    updateIndicator();

    rangeMin.addEventListener('input', () => {
      if (parseInt(rangeMin.value) >= maxValue - gap) {
        rangeMin.value = maxValue - gap;
        ['input', 'change'].forEach((evt) =>
          rangeMin.dispatchEvent(new Event(evt, { bubbles: true })),
        );
      }
      minValue = parseInt(rangeMin.value);
      updateIndicator();
    });

    rangeMax.addEventListener('input', () => {
      if (parseInt(rangeMax.value) <= minValue + gap) {
        rangeMax.value = minValue + gap;
        ['input', 'change'].forEach((evt) =>
          rangeMax.dispatchEvent(new Event(evt, { bubbles: true })),
        );
      }
      maxValue = parseInt(rangeMax.value);
      updateIndicator();
    });
  });
};

export { initInputs };
